export enum AccountActionsEnum {
  ACCOUNT_CHECKLIST_TEMPLATES_GET = 'ACCOUNT_CHECKLIST_TEMPLATES_GET',
  ACCOUNT_CHECKLIST_TEMPLATES_GET_REQUEST = 'ACCOUNT_CHECKLIST_TEMPLATES_GET_REQUEST',
  ACCOUNT_CHECKLIST_TEMPLATES_GET_SUCCESS = 'ACCOUNT_CHECKLIST_TEMPLATES_GET_SUCCESS',
  ACCOUNT_CHECKLIST_TEMPLATES_GET_FAILURE = 'ACCOUNT_CHECKLIST_TEMPLATES_GET_FAILURE',
  ACCOUNT_REQUIREMENT_TEMPLATES_GET = 'ACCOUNT_REQUIREMENT_TEMPLATES_GET',
  ACCOUNT_REQUIREMENT_TEMPLATES_GET_REQUEST = 'ACCOUNT_REQUIREMENT_TEMPLATES_GET_REQUEST',
  ACCOUNT_REQUIREMENT_TEMPLATES_GET_SUCCESS = 'ACCOUNT_REQUIREMENT_TEMPLATES_GET_SUCCESS',
  ACCOUNT_REQUIREMENT_TEMPLATES_GET_FAILURE = 'ACCOUNT_REQUIREMENT_TEMPLATES_GET_FAILURE',
  ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET = 'ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET',
  ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_REQUEST = 'ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_REQUEST',
  ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_SUCCESS = 'ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_SUCCESS',
  ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_FAILURE = 'ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_FAILURE',
  ACCOUNT_ORGANIZATIONS_GET = 'ACCOUNT_ORGANIZATIONS_GET',
  ACCOUNT_ORGANIZATIONS_GET_REQUEST = 'ACCOUNT_ORGANIZATIONS_GET_REQUEST',
  ACCOUNT_ORGANIZATIONS_GET_SUCCESS = 'ACCOUNT_ORGANIZATIONS_GET_SUCCESS',
  ACCOUNT_ORGANIZATIONS_GET_FAILURE = 'ACCOUNT_ORGANIZATIONS_GET_FAILURE',
  ACCOUNT_ORGANIZATIONS_RESET = 'ACCOUNT_ORGANIZATIONS_RESET',
  ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET = 'ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET',
  ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_REQUEST = 'ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_REQUEST',
  ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_SUCCESS = 'ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_SUCCESS',
  ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_FAILURE = 'ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_FAILURE',
}
